<template>
    <div
        class="Card"
        :class="[`is-${size}`, `is-${variant}`, { 'is-rounded': rounded, 'is-elevated': elevated }]"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: 'medium',
        },
        variant: {
            type: String,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        elevated: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
.Card {
    background: var(--color-white);
    padding: 40px 50px;
    border-radius: 5px;
    border: 0.5px solid var(--color-border-light);

    &.is-rounded {
        border-radius: 16px;
    }

    &.is-elevated {
        box-shadow: 0 8px 64px 0 rgba(0, 0, 0, 0.04);
    }

    &.is-dark {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border: 0.5px solid rgba(255, 255, 255, 0.1);
        color: var(--color-text-white);

        &.is-elevated {
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }
    }

    @media screen and (max-width: $breakpoint-tablet-portrait) {
        padding: 20px;
    }

    &.is-info,
    &.is-warning {
        display: flex;
        flex-direction: column;
        padding: 10px;
        position: relative;

        i {
            font-size: 1rem;
            cursor: pointer;
        }

        h2 {
            font-size: 1rem;
            font-weight: 700;
        }

        h3 {
            font-size: 1rem;
            font-weight: 700;
        }

        p {
            font-size: 0.75rem;
        }

        button {
            .Label {
                font-size: 0.75rem;
            }
        }
    }

    &.is-warning {
        border: 0.5px solid var(--color-red);
        color: var(--color-red);

        h3 {
            color: var(--color-red);
        }
    }

    &.is-small {
        padding: 20px 30px;
    }
}
</style>
